export default "__VITE_ASSET__3877ab1e__"